export default {
	getFields(Selector) {
		return {
			"another_delivery[first_name]": {
				required: true,
				minlength: 3
			},
			"another_delivery[last_name]": {
				required: true,
				minlength: 2
			},
			"another_delivery[country]": 'required',
			"another_delivery[street]": 'required',
			"another_delivery[hnumber]": 'required',
			"another_delivery[postal]": {
				required : true,
				postalPL : true
			},
			"another_delivery[city]": 'required',
			"another_delivery[phone]": {
				required : true,
				phonePL: true,
				minlength: 9,
				maxlength: 15
			},
		}
	}
}export default {
	getFields(Selector) {
		return {
			"another_delivery[first_name]": {
				required: true,
				minlength: 3
			},
			"another_delivery[last_name]": {
				required: true,
				minlength: 2
			},
			"another_delivery[country]": 'required',
			"another_delivery[street]": 'required',
			"another_delivery[hnumber]": 'required',
			"another_delivery[postal]": {
				required : true,
				postalPL : true
			},
			"another_delivery[city]": 'required',
			"another_delivery[phone]": {
				required : true,
				phonePL: true,
				minlength: 9,
				maxlength: 15
			},
		}
	}
}